
export default {
  props: {
    rating: {
      type: Number,
      required: true,
    },
    reviews: {
      type: Number,
      default: 0,
    },
    color: {
      type: Boolean,
      default: true,
    },
    hideSubunits: {
      type: Boolean,
      default: false,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    title() {
      switch (this.rating) {
        case 10:
        case 9:
          return 'Wonderful'

        case 8:
          return 'Very Good'

        case 7:
          return 'Good'

        case 6:
          return 'Pleasant'

        default:
          return ''
      }
    },
  },
}
